// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiDownloadEventMenu__pNG74 {
  width: 210px !important;
  padding: 0 !important;
  background: var(--tables-secondary-row-sub-title-surface) !important;
  text-align: left !important;
  opacity: 1 !important;
  border-radius: 0;
  box-shadow: var(--modal-box-shadow);
  z-index: 20 !important;
}
@media print {
  .aiDownloadEventMenu__pNG74 {
    display: none;
  }
}

.loader__RHyfm {
  position: absolute;
  top: 50%;
  left: 21px;
  transform: translate(-50%, -50%);
}
.loader__RHyfm > img {
  width: 18px;
  height: 18px;
}

.aiDownloadEventItem__Mo5W1 {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  text-transform: uppercase;
  color: var(--context-menu-text);
  font-size: 10px;
  border: 1px solid var(--context-menu-stroke);
  border-bottom: unset;
}
.aiDownloadEventItem__Mo5W1:hover {
  font-weight: 500;
  background-color: inherit;
}
.aiDownloadEventItem__Mo5W1:last-child {
  border-bottom: 1px solid var(--context-menu-stroke);
}
.aiDownloadEventItem__Mo5W1 svg {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.aiDownloadEventItem__Mo5W1 .downloadIcon__OxCfG {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.aiDownloadEventItem__Mo5W1 .downloadIcon__OxCfG path {
  fill: var(--buttons-surface);
}
.aiDownloadEventItem__Mo5W1 .printIcon__iIq5Q path {
  stroke: var(--buttons-surface);
}
.aiDownloadEventItem__Mo5W1 .copyLinkIcon__ssDRk path {
  stroke: var(--buttons-surface);
}
.aiDownloadEventItem__Mo5W1 .copyTextIcon__ZnMXT path {
  fill: var(--buttons-surface);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/DownloadAIDetailsMenu/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,uBAAA;EACA,qBAAA;EACA,oEAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mCAAA;EACA,sBAAA;AAzEF;AA2EE;EAVF;IAWI,aAAA;EAxEF;AACF;;AA0EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;AAvEF;AAyEE;EACE,WAAA;EACA,YAAA;AAvEJ;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,4CAAA;EACA,oBAAA;AAxEF;AA0EE;EACE,gBAAA;EACA,yBAAA;AAxEJ;AA2EE;EACE,mDAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA1EJ;AA6EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3EJ;AA6EI;EACE,4BAAA;AA3EN;AAgFI;EACE,8BAAA;AA9EN;AAmFI;EACE,8BAAA;AAjFN;AAsFI;EACE,4BAAA;AApFN","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.aiDownloadEventMenu {\n  width: 210px !important;\n  padding: 0 !important;\n  background: var(--tables-secondary-row-sub-title-surface) !important;\n  text-align: left !important;\n  opacity: 1 !important;\n  border-radius: 0;\n  box-shadow: var(--modal-box-shadow);\n  z-index: 20 !important;\n\n  @media print {\n    display: none;\n  }\n}\n.loader {\n  position: absolute;\n  top: 50%;\n  left: 21px;\n  transform: translate(-50%, -50%);\n\n  & > img {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.aiDownloadEventItem {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  text-transform: uppercase;\n  color: var(--context-menu-text);\n  font-size: 10px;\n  border: 1px solid var(--context-menu-stroke);\n  border-bottom: unset;\n\n  &:hover {\n    font-weight: 500;\n    background-color: inherit;\n  }\n\n  &:last-child {\n    border-bottom: 1px solid var(--context-menu-stroke);\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 6px;\n  }\n\n  .downloadIcon {\n    width: 20px;\n    height: 20px;\n    margin-right: 6px;\n\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n\n  .printIcon {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n\n  .copyLinkIcon {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n\n  .copyTextIcon {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aiDownloadEventMenu": `aiDownloadEventMenu__pNG74`,
	"loader": `loader__RHyfm`,
	"aiDownloadEventItem": `aiDownloadEventItem__Mo5W1`,
	"downloadIcon": `downloadIcon__OxCfG`,
	"printIcon": `printIcon__iIq5Q`,
	"copyLinkIcon": `copyLinkIcon__ssDRk`,
	"copyTextIcon": `copyTextIcon__ZnMXT`
};
module.exports = ___CSS_LOADER_EXPORT___;
